import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function CTSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-631">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-632">
        <div data-id="element-633">
          <h2 className="text-3xl font-bold mb-1" data-id="element-634">Bodor C-T Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-635">
            Best performance, general use, combination plate and tube fiber
            laser cutting machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-636">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-637">
          <div className="md:col-span-5 flex justify-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-638">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Sheet%20Metal%20%26%20Tube%20Cutter%20Combo/C-T%20Series%20Sheetl%20Metal%20%26%20Tube%20Laser%20Cutting%20-%20Bodor.png" alt="Bodor C-T Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl" data-id="element-639" />
          </div>
          <div className="md:col-span-7" data-id="element-640">
            <ul className="space-y-4 text-gray-700" data-id="element-641">
              <li data-id="element-642">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-643">
                  Double Fast Exchange Tables
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-644">
                  Fast exchange of two tables greatly improves efficiency.
                  Chain-drive system has better rigidity and higher accuracy.
                </span>
              </li>
              <li data-id="element-645">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-646">
                  Tenon-and-mortise Welded Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-647">
                  Stronger bearing capacity. Solder joint fixing and structural
                  bearing ensure long-standing operation stability. Welded
                  structure improves shock absorption.
                </span>
              </li>
              <li data-id="element-648">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-649">
                  Double Automatic Centering Electric Chucks
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-650">
                  Easy to operate, little maintenance. Brand new motor gives
                  accurate control. Modular chuck components independently
                  developed.
                </span>
              </li>
              <li data-id="element-651">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-652">
                  Active Obstacle Avoidance
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-653">
                  Intelligent Anti-collision - 360° radar system. Higher
                  Efficiency, Lower Cost - lowers damage rate, reduces
                  maintenance cost.
                </span>
              </li>
              <li data-id="element-654">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-655">
                  All-around Protective Covering
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-656">
                  Full protection, isolation of laser radiation pollution,
                  automatic soot collection, clean operation area.
                </span>
              </li>
              <li data-id="element-657">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-658">
                  Automatic focusing function of laser head
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-659">
                  Setting perforation and cutting focal length. Suitable for
                  multiple focal lengths, auto-adjusted based on sheet
                  thickness.
                </span>
              </li>
              <li data-id="element-660">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-661">
                  Extruded Aluminum Beam
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-662">
                  Aviation-level material, enhanced rigidity, reduces beam
                  deformation.
                </span>
              </li>
              <li data-id="element-663">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-664">
                  BodorCloud IoT
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-665">
                  After-sale service, digital management, real-time monitoring,
                  multi-device access.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-666">
              <a href="https://www.peakedm.com/m7/Bodor%20C%20Series--c-series-economical-fiber-laser-plate-cutting-machine.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-667">
                <span className="mr-2" data-id="element-668">+</span> Discover More
              </a>
              <span className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md opacity-80 cursor-not-allowed" data-id="element-669">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-670" /> Download Brochure
              </span>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-671">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-672">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-673">
              <tr data-id="element-674">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/2" data-id="element-675">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/2" data-id="element-676">
                  C3T
                </th>
              </tr>
            </thead>
            <tbody data-id="element-677">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-678">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-679">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center" data-id="element-680">3048mm*1524mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-681">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-682">
                  Laser Output Power
                </th>
                <td className="px-6 py-4 text-center" data-id="element-683">
                  6000w/3000w/2000w/1500w
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-684">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-685">
                  Positioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-686">±0.05mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-687">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-688">
                  Repositioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-689">±0.03mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-690">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-691">
                  Max. linkage speed
                </th>
                <td className="px-6 py-4 text-center" data-id="element-692">100m/min</td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-693">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-694">
                  Max. acceleration
                </th>
                <td className="px-6 py-4 text-center" data-id="element-695">1G</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}